export const MATCHING_VARIANT_KEYS = [
  "green",
  "blue",
  "yellow",
  "orange",
] as const;
export type MatchingVariant = (typeof MATCHING_VARIANT_KEYS)[number];

export function getMatchingVariant(score: number): MatchingVariant {
  if (score > 90) return "green";
  if (score >= 70) return "blue";
  if (score >= 40) return "yellow";
  return "orange";
}
